import { apiGet, apiPatch, apiPost } from "./client";

export type PayMethod = {
  id: string;
  code: string;
  name: string;
  isDefault: boolean;
  worksOffline: boolean;
  glAccountCode: string;
  deactivatedAt: string | null;
  updatedAt: string;
};

export function listPayMethods(
  companyRef: string,
  opts?: { includeDeactivated?: boolean },
) {
  const q = opts?.includeDeactivated ? "?includeDeactivated=1" : "";
  return apiGet<{ methods: PayMethod[] }>(
    `/c/${companyRef}/pay-methods${q}`,
  );
}

export function createPayMethod(
  companyRef: string,
  body: {
    name: string;
    code?: string;
    worksOffline?: boolean;
    isDefault?: boolean;
    glAccountCode?: string;
  },
) {
  return apiPost<{ method: PayMethod }>(`/c/${companyRef}/pay-methods`, body);
}

export function updatePayMethod(
  companyRef: string,
  methodId: string,
  body: {
    name?: string;
    worksOffline?: boolean;
    isDefault?: boolean;
    reactivate?: boolean;
    glAccountCode?: string;
  },
) {
  return apiPatch<{ method: PayMethod }>(
    `/c/${companyRef}/pay-methods/${methodId}`,
    body,
  );
}

export function deactivatePayMethod(companyRef: string, methodId: string) {
  return apiPost<{ method: PayMethod }>(
    `/c/${companyRef}/pay-methods/${methodId}/deactivate`,
  );
}
